(function () {
  function initPackages() {
    document.querySelectorAll('[data-package]').forEach(function (label) {
      label.addEventListener('click', function () {
        document.querySelectorAll('[data-package]').forEach(function (item) { item.classList.remove('active'); });
        label.classList.add('active');
        var input = label.querySelector('input[type="radio"]');
        if (input) input.checked = true;
        var total = document.querySelector('[data-order-total]');
        if (total) total.textContent = label.getAttribute('data-price') || '';
      });
    });
  }

  function initBottle() {
    var root = document.querySelector('.fortimax[data-bottle-module]');
    var stage = document.querySelector('[data-fortimax-stage]');
    if (!root || !stage || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var moduleUrl = root.getAttribute('data-bottle-module');
    var labelUrl = root.getAttribute('data-label-url');
    var hint = document.querySelector('[data-rotation-hint]');
    if (!moduleUrl || !labelUrl) return;
    import(moduleUrl).then(function (mod) { return mod.mount(stage, hint, labelUrl); }).catch(function () {});
  }

  function initMobileOrderBar() {
    var bar = document.querySelector('.mobile-order-bar');
    var order = document.querySelector('#comanda');
    var footer = document.querySelector('footer');
    if (!bar || !('IntersectionObserver' in window)) return;

    var coveredSections = new Set();
    function syncBar() {
      var hidden = coveredSections.size > 0;
      bar.classList.toggle('is-hidden', hidden);
      bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      bar.setAttribute('tabindex', hidden ? '-1' : '0');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) coveredSections.add(entry.target);
        else coveredSections.delete(entry.target);
      });
      syncBar();
    }, { rootMargin: '-8% 0px -8% 0px', threshold: 0 });

    if (order) observer.observe(order);
    if (footer) observer.observe(footer);
  }

  function init() {
    initPackages();
    initMobileOrderBar();
    window.setTimeout(initBottle, 450);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
